import ProjectSsl from './ProjectSsl';

export default ProjectSsl;


// WEBPACK FOOTER //
// ./resources/assets/js/components/ProjectSsl/index.js